import { render, staticRenderFns } from "./EbTabs.vue?vue&type=template&id=34ac40de"
import script from "./EbTabs.vue?vue&type=script&lang=js"
export * from "./EbTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports